export default {
    cancelText: 'Avbryt',
};
